import React from 'react';

const PickupLocationList = ({
  enhancedLocations,
  locationDistances,
  selectedPickupGroupId,
  isLocationFailed, // function: (location) => boolean
  formatPickupLocation, // function: (location) => string
  onLocationSelect, // function: (locationId) => void
}) => {
  if (Object.keys(enhancedLocations).length === 0) {
    // This case should ideally be handled by the parent, 
    // but included here if this component might be used where enhancedLocations could be empty.
    return (
      <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-md">
        <p className="text-yellow-700">No pickup locations available.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4 mb-4">
      {Object.entries(enhancedLocations).map(([locationId, location]) => {
        const locationFailed = isLocationFailed(location);
        const distance = locationDistances[locationId];
        const isSelected = selectedPickupGroupId === locationId;
        
        return (
          <div 
            key={locationId} 
            className={`p-3 border rounded flex justify-between items-center cursor-pointer ${ 
              locationFailed ? 'opacity-50 bg-gray-100 cursor-not-allowed' :
              isSelected ? 'border-indigo-500 bg-indigo-50 shadow-md' : 'border-gray-200 hover:border-gray-300' // Added shadow-md for selected
            }`}
            onClick={() => {
              if (!locationFailed) {
                onLocationSelect(locationId);
              }
            }}
          >
            <div>
              <h4 className="font-medium">{'Pickup in '+formatPickupLocation(location)}</h4>
              {locationFailed && (
                <p className="text-xs text-red-500 mt-1">
                  Location details unavailable
                </p>
              )}
              {!locationFailed && (
                 <p className="text-sm text-gray-500 mt-1">
                   Contact shop for pickup time and please bring ID for pickup
                 </p>
              )}
            </div>
            <div className="font-medium ml-4 whitespace-nowrap">
              {locationFailed ? '' : distance}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PickupLocationList; 